import { SaSet } from './types';

const ai: SaSet = {
  categories: [
    'Begrip van AI',
    'Toepassen in je werk',
    'Kritisch beoordelen',
    'Veilig & verantwoord',
    'Zelf aan de slag',
  ],
  items: [
    // Begrip van AI
    { category: 'Begrip van AI', text: 'Ik begrijp in grote lijnen wat AI is.', quick: true },
    { category: 'Begrip van AI', text: 'Ik kan in gewone taal uitleggen wat een chatbot voor je kan doen.' },
    { category: 'Begrip van AI', text: 'Ik snap dat AI antwoorden geeft op basis van patronen en niet echt ‘nadenkt’.', quick: true },
    { category: 'Begrip van AI', text: 'Ik herken voorbeelden van AI die ik in het dagelijks leven tegenkom.' },
    { category: 'Begrip van AI', text: 'Ik begrijp dat AI alleen zo goed is als de informatie waarmee het gevoed is.' },
    { category: 'Begrip van AI', text: 'Ik voel me op mijn gemak als het gesprek over AI gaat.' },

    // Toepassen in je werk
    { category: 'Toepassen in je werk', text: 'Ik gebruik AI om een tekst sneller op papier te krijgen.', quick: true },
    { category: 'Toepassen in je werk', text: 'Ik kan AI vragen om een lange tekst voor me samen te vatten.' },
    { category: 'Toepassen in je werk', text: 'Ik weet hoe ik mijn vraag aan AI duidelijk genoeg stel om een bruikbaar antwoord te krijgen.', quick: true },
    { category: 'Toepassen in je werk', text: 'Ik zet AI in om op ideeën te komen als ik even vastzit.' },
    { category: 'Toepassen in je werk', text: 'Ik merk dat AI me tijd bespaart bij klusjes die ik vaak herhaal.' },
    { category: 'Toepassen in je werk', text: 'Ik durf te experimenteren met AI om te kijken wat het voor mijn werk kan betekenen.' },

    // Kritisch beoordelen
    { category: 'Kritisch beoordelen', text: 'Ik controleer of een antwoord van AI klopt voordat ik het gebruik.', quick: true },
    { category: 'Kritisch beoordelen', text: 'Ik weet dat AI soms dingen heel stellig zegt die toch niet waar zijn.', quick: true },
    { category: 'Kritisch beoordelen', text: 'Ik kan inschatten wanneer een antwoord te mooi of te makkelijk lijkt.' },
    { category: 'Kritisch beoordelen', text: 'Ik vraag door als een antwoord van AI me niet helemaal overtuigt.' },
    { category: 'Kritisch beoordelen', text: 'Ik merk dat ik AI niet voor alles even goed kan vertrouwen.' },
    { category: 'Kritisch beoordelen', text: 'Ik vergelijk een uitkomst van AI met wat ik zelf al weet.' },

    // Veilig & verantwoord
    { category: 'Veilig & verantwoord', text: 'Ik let erop dat ik geen gevoelige informatie in een AI-tool zet.', quick: true },
    { category: 'Veilig & verantwoord', text: 'Ik weet dat ik AI niet zomaar over privégegevens van anderen moet vertellen.' },
    { category: 'Veilig & verantwoord', text: 'Ik denk na over de gevolgen voordat ik iets van AI overneem.' },
    { category: 'Veilig & verantwoord', text: 'Ik ben eerlijk tegen anderen als ik AI heb gebruikt bij mijn werk.' },
    { category: 'Veilig & verantwoord', text: 'Ik begrijp dat AI vooroordelen kan overnemen en daardoor oneerlijk kan uitpakken.' },
    { category: 'Veilig & verantwoord', text: 'Ik voel me verantwoordelijk voor wat ik uiteindelijk met de hulp van AI maak.' },

    // Zelf aan de slag
    { category: 'Zelf aan de slag', text: 'Ik probeer zelf een AI-tool uit als ik er een tegenkom.', quick: true },
    { category: 'Zelf aan de slag', text: 'Ik blijf bijleren over AI omdat er steeds nieuwe mogelijkheden bijkomen.' },
    { category: 'Zelf aan de slag', text: 'Ik durf hulp of uitleg te vragen als ik er met AI niet uitkom.' },
    { category: 'Zelf aan de slag', text: 'Ik deel handige AI-tips met collega’s om me heen.' },
    { category: 'Zelf aan de slag', text: 'Ik pas mijn aanpak aan als een AI-tool niet het resultaat geeft dat ik wil.' },
    { category: 'Zelf aan de slag', text: 'Ik kijk met nieuwsgierigheid naar wat AI me in de toekomst kan opleveren.' },
  ],
};

export default ai;
